/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Components.Controls {
  "use strict";

  export class SmartTilePropMenuShortcut implements angular.IComponentOptions {
    templateUrl = "app/components/controls/smartCenterDesigner/propertyViews/smartTilePropMenuShortcut.component.html";
    bindings: any = {
      tile: '=?',
      isAvailableCo: '=?'
    }
    controller = class SmartTilePropMenuShortcutController {
      public tile: Meevo.Model.SmartCenterSmartTile;
      public menuItems: Meevo.IMenuItem[] = [];
      public selectedMenuItem: Meevo.IMenuItem = null;
      public isAvailableCo: boolean;

      private shortcutProp: Meevo.Model.SmartTileParameter;
      private imageProp: Meevo.Model.SmartTileParameter;

      private coRoutes: string[] = [
        this.appSettings.ROUTE_NAMES.walkinManagerSettings,
        this.appSettings.ROUTE_NAMES.clientPoint,
        this.appSettings.ROUTE_NAMES.reports,
        this.appSettings.ROUTE_NAMES.memberships
      ];

      static $inject = ["meevo.menuService", 'meevo.convo.ConvoService', 'meevo.AppSettings'];

      constructor(private menuService: Meevo.MenuService,
        private convoService: Meevo.Convo.IConvoService,
        private appSettings: Meevo.Components.Common.IAppSettings
      ) {

      }

      $onInit(): void {
        // Set menu items from filtered listing in menu service
        this.menuItems = this.isAvailableCo ? _.filter(this.menuService.featureSmartTileMenuItems, m => _.contains(this.coRoutes, m.stateName)) : this.menuService.featureSmartTileMenuItems;
        this.shortcutProp = this.tile.parsedParameters[Meevo.Model.SmartTileParameterNames.shortcut];
        this.imageProp = this.tile.parsedParameters[Meevo.Model.SmartTileParameterNames.image];
        if (this.shortcutProp && this.shortcutProp.parameterValue) {
            let that = this;
            that.menuItems.forEach(function (item, index, array) {
                if (item.stateName.toLowerCase() == that.shortcutProp.parameterValue || (item.stateName == 'appointmentBook' && that.shortcutProp.parameterValue == 'appointment')) {
                    that.selectedMenuItem = that.menuItems[index];
                    that.onSelectionChanged();
                }
            })  
        }
      }

      protected onSelectionChanged(): void {
        const defaultConvo = this.convoService.getDefaultConvoForState(this.selectedMenuItem.stateName);
        this.shortcutProp.parameterValue = defaultConvo ? defaultConvo : this.selectedMenuItem.stateName;
        this.imageProp.parameterValue = this.selectedMenuItem.icon;
        this.tile.displayNameOverride = this.selectedMenuItem.contentKey;
      }
    }
  }

  angular.module("meevo.components.controls")
    .component("stpMenuShortcut", new SmartTilePropMenuShortcut());
}
